import { useTranslation } from 'react-i18next';
import { IconButton } from '@chakra-ui/react';

import FeatherIcon from '../icon/FeatherIcon';

interface Props {
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
}

export const NavigationMenuToggle = ({ setIsOpen, isOpen }: Props) => {
  const { t } = useTranslation('shared');

  return (
    <IconButton
      display={{ base: 'inline-flex', md: 'none' }}
      aria-label={isOpen ? t('navigation.hideNav') : t('navigation.showNav')}
      aria-expanded={isOpen}
      variant='menuIcon'
      background='transparent'
      icon={
        isOpen ? (
          <FeatherIcon name='x' stroke='neutral400' size={28} />
        ) : (
          <FeatherIcon name='menu' color='neutral400' />
        )
      }
      title={isOpen ? t('navigation.hideNav') : t('navigation.showNav')}
      onClick={() => setIsOpen(!isOpen)}
    />
  );
};

export default NavigationMenuToggle;
